// import FillCarsSlider from "./component/carSlider/FillCarsSlider";
// import FillHistoryServices from "./component/history/FillHistoryServices";
// import OperateHome from "./component/operateHome/OperateHome";

import FillCarsSlider from "../car/fill-cars-slider/fill-cars-slider.js";
import FillHistoryServices from "../fill-history-services/fill-history-services.js";
import OperateHome from "./OperateHome/OperateHome.jsx";

import SectionHeader from "./component/SectionHeader/SectionHeader.jsx";
import styles from "./HomePage.module.css";




const HomePage = () => {

    return (

        <main className={styles.page}>

            {/* خودروها */}

            <section className={styles.section}>

                <SectionHeader

                    title="خودروهای من"

                    link="/all-cars"

                />

                <FillCarsSlider />

            </section>

            {/* خلاصه وضعیت */}

            <section className={styles.section}>

                {/* <HomeSummaryCard /> */}

            </section>

            {/* سرویس‌های نزدیک */}

            <section className={styles.section}>

                <SectionHeader

                    title="نزدیک‌ترین سرویس‌ها"

                    link="/all-services"

                />

                <OperateHome />

            </section>

            {/* آخرین سوابق */}

            <section className={styles.section}>

                <SectionHeader

                    title="آخرین سوابق"

                    link="/all-operdon"

                />

                <FillHistoryServices />

            </section>

        </main>

    );

};

export default HomePage;